import type { MapboxMap } from "@/layers/MapboxMap";
import { Area, CoordinateSystem } from "@mm/api.meteomatics.com";

export function getAreaFromMap(map: MapboxMap): Area<CoordinateSystem.WGS84> {
  const bounds = map.getBounds();
  const center = map.getCenter();
  return new Area(CoordinateSystem.WGS84, {
    east: bounds ? bounds.getEast() : center.lng,
    west: bounds ? bounds.getWest() : center.lng,
    north: bounds ? bounds.getNorth() : center.lat,
    south: bounds ? bounds.getSouth() : center.lat,
  });
}
